import type { Dtos } from "@inrev/common";
import { Icon } from "@portal/components/primitives";
import { DateTime } from "luxon";
import { FC } from "react";
import { BusinessIdentityPanel } from "./BusinessIdentityPanel";
import { FsrPanel } from "./FsrPanel";
import { PublicRecordsPanel } from "./PublicRecordsPanel";
import { TradelinesPanel } from "./TradelinesPanel";
import { UccFilingsPanel } from "./UccFilingsPanel";

export type CompanyCreditReportDetailProps = {
	report:
		| Dtos.Admin.SuretyAccount.Get.Response["companies"][number]["creditReports"][number]
		| undefined;
	company: Dtos.Admin.SuretyAccount.Get.Response["companies"][number];
};

export const CompanyCreditReportDetail: FC<CompanyCreditReportDetailProps> = ({
	report,
	company,
}) => {
	if (!report?.success) {
		return null;
	}

	return (
		<div
			className="bg-surface-base w-full space-y-0 rounded-b-xl"
			data-amp-mask
			data-testid="company_credit_report_detail"
		>
			<div className="space-y-4 px-1">
				<FsrPanel report={report} />
				<PublicRecordsPanel report={report} />
				<TradelinesPanel report={report} />
				<UccFilingsPanel report={report} />
				<BusinessIdentityPanel report={report} company={company} />
			</div>
			<div
				className="text-secondary mt-4 flex flex-wrap items-center justify-between gap-3 border-t border-bc-default pt-4 text-[13px]"
				data-testid="company_credit_report_footer"
			>
				<div className="flex items-center gap-2">
					<Icon type="clock" size="small" color="tertiary" />
					<span>
						Pulled {DateTime.fromISO(report.createdAt).toFormat("MM/dd/yyyy")} from Experian
						Business
					</span>
				</div>
			</div>
		</div>
	);
};
